import { render, staticRenderFns } from "./DisplayReview.vue?vue&type=template&id=4278c965&scoped=true&"
import script from "./DisplayReview.vue?vue&type=script&lang=js&"
export * from "./DisplayReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4278c965",
  null
  
)

export default component.exports